// extracted by mini-css-extract-plugin
module.exports = {"wrap":"menu-icon_wrap__1rgBz","bar1":"menu-icon_bar1__yRG7z","bar2":"menu-icon_bar2__1QFfl","bar3":"menu-icon_bar3__1KhOP","change":"menu-icon_change__1iAXP"};